import { Types } from '@fiverr-private/theme';
import { AvatarSizeType } from '../Avatar/types';

export const AVATARS_MAX_LENGTH = 99;
export const MAX_TOOLTIP_ITEMS = 5;
export const OVERLAY_DISTANCE = 3;
export const LEFT_AVATARS_PADDING: { [key in AvatarSizeType]: Types.BoxType['padding'] } = {
    xs: '1.5',
    sm: '2',
    md: '4',
    lg: '5',
    xl: '5',
    '2xl': '8',
    '3xl': '10',
    '4xl': '16',
};
